// extracted by mini-css-extract-plugin
export default {"button":"DownloadReportButton_button__I+Lrw"};